import { defineStore } from 'pinia';
import { UserInfoInterface } from '@/lib/typings';
const defaultAvatar = 'https://img-fe.tengzhihh.com/image/70660262f23e95-600x600.png';

export const rootStore = defineStore('rootStore', {
  state: () => {
    return {
      defaultAvatar,
      currentUserInfo: {
        teamName: '',
        avatar: defaultAvatar,
        avatar_color: '',
        name: '',
        teamRole: '',
        teamId: 0,
        id: 0,
        isSuper: false,
        enable_qywx: false,
        enable_h5: false,
        enable_gzh: false,
        enable_virtual_robot: false,
        dingding_unionid: '',
        unify_id: '',
      },
      currentCSInfo: {
        state: 0,
        type: 0,
      },
      msgBodyMoreFlag: true,
      msgBodyMoreAIMsgFlag: true,
      historyChatListMoreFlag: true,
      userMenu: [],
      mHomeChatActiveTab: 'personal',
      platformType: 0, // 0：链橘，1：企微宝
      dmSlotOptions: [], // 消息槽位类型选项
      pageQueryCache: {}, // 页面查询参数缓存
      apiPathHookCache: {}, // 接口请求数据缓存
    };
  },
  getters: {},
  actions: {
    setUserMenu(menu: any) {
      this.userMenu = menu;
    },
    setCSInfo(info: UserInfoInterface) {
      Object.assign(this.currentCSInfo, info);
    },
    setUserInfo(info: UserInfoInterface) {
      Object.assign(this.currentUserInfo, info);
    },
    changeCSCurrentStatus(v: number) {
      this.currentCSInfo.state = v;
    },
    initMsgBodyMoreFlag() {
      this.msgBodyMoreFlag = true;
    },
    initMsgBodyMoreAIMsgFlag() {
      this.msgBodyMoreAIMsgFlag = true;
    },
    deleteMsgBodyMoreFlag() {
      this.msgBodyMoreFlag = false;
    },
    deleteMsgBodyMoreAIMsgFlag() {
      this.msgBodyMoreAIMsgFlag = false;
    },
    initHistoryChatListMoreFlag() {
      this.historyChatListMoreFlag = true;
    },
    deleteHistoryChatListMoreFlag() {
      this.historyChatListMoreFlag = false;
    },
    setMHomeChatActiveTab(val: string) {
      this.mHomeChatActiveTab = val;
    },
    setPlatformType(val: number) {
      this.platformType = val;
    },
    setDmSlotOptions(val: any) {
      this.dmSlotOptions = val;
    },
    setPageQueryCache(val: any) {
      this.pageQueryCache = {
        ...this.pageQueryCache,
        ...val,
      };
    },
    setApiPathHookCache(field: string, val: any) {
      if (field) {
        this.apiPathHookCache = {
          ...this.apiPathHookCache,
          [field]: val,
        };
      }
    },
  },
});
